import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import OAuthSignIn from './OAuthSignIn';
import Label from './components/Label';

import {post, setAccessToken} from '../../api';
import LogoRender from '../cmp/LogoRender';
import StyledButton from '../cmp/themed/StyledButton';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import FormattedHelmet from '../cmp/intl/FormattedHelmet';
import FormInput from './components/FormInput';
import RenderError from './components/RenderError';
import AuthContainer from './components/AuthContainer';
import CountrySelector from './components/CountrySelector';
import * as localStorage from '../../tools/storage';
import RenderLegalDocLink from '../cmp/RenderLegalDocLink';
import SponsorName from './components/SponsorName';

class CreateAccount extends Component {

    state = {
        email: '',
        password: '',
        name: '',
        instagram: '', website: '', twitter: '', address: '',
        country: '', comments: '', phone: '', facebook: '', youtube: '', other_social_networks: '',
        loading: false,
        error: null
    }

    onChange = (key) => (e) => {
        this.setState({[key]: e.target.value});
    }

    handleFormSubmit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!this.shouldEnable()) {
            return;
        }

        const {name, email, password, instagram, website, twitter, address, country, comments, phone, facebook, youtube, other_social_networks} = this.state;
        this.setState({loading: true, code: null});
        const ref = localStorage.getItem('ref');
        const utm_source = localStorage.setItem('utm_source');
        post('/register', {
            name,
            email,
            password,
            instagram,
            website,
            twitter,
            address,
            country,
            comments,
            phone,
            facebook,
            youtube,
            other_social_networks,
            ref,
            utm_source
        }).then((data) => {
            if (data.access_token) {
                setAccessToken(data.access_token)
                window.location = `/${this.props.isEmbedded ? '?embedded=1' : ''}`;
            } else {
                const {code} = data;
                this.setState({code, loading: false});
            }
        }).catch(() => {
            this.setState({loading: false});
        });
    }

    emailValidator = new RegExp(/\S+@\S+\.\S+/);


    shouldEnable = () => {
        const {email, password} = this.state;
        for (let x = 0; x < fields.length; x++) {
            const stateVal = this.state[dbKeys[x]];
            const has = this.props['signup' + fields[x]];
            const required = this.props['signup' + fields[x] + 'Required'];
            if (has && required) {
                if (!stateVal) {
                    return false;
                }
            }
        }
        return email && password && this.emailValidator.test(email);

    }


    render() {
        const {email, password, name, instagram, website, twitter, address, facebook, youtube, phone, country, comments, other_social_network} = this.state;
        if (!this.props.allow_partner_registrations) {
            return <p className="alert alert-danger"><FormattedMessage
                id={"We are not accepting registrations at this moment. Kindly check back later"}/></p>;
        }
        return (
            <AuthContainer>
                <FormattedHelmet id={'createAccount'}/>
                <div className={'text-center mb-4'}>
                    <LogoRender/>
                </div>
                <h1><FormattedMessage id={'createAccount'}/></h1>
                <div className={'card'}>
                    <div className={'card-body'}>
                        {
                            this.state.code && <RenderError code={this.state.code}/>
                        }
                        <form onSubmit={this.handleFormSubmit}>
                            <FormInput id={'yourName'} required={this.props.signupNameRequired}>
                                <input type={'text'} autoComplete={'name'} required={this.props.signupNameRequired}
                                       value={name} name={'name'} onInput={this.onChange('name')}
                                       className={'form-control'}
                                />
                            </FormInput>
                            {
                                this.props.signupPhone &&
                                <FormInput id={'Phone'} required={this.props.signupPhoneRequired}>
                                    <input type={'text'} autoComplete={'tel'}
                                           required={this.props.signupPhoneRequired}
                                           value={phone} name={'phone'}
                                           onInput={this.onChange('phone')}
                                           className={'form-control'}
                                    />
                                </FormInput>
                            }
                            {
                                this.props.signupInsta && <InstaOrTwitter required={this.props.signupInstaRequired}
                                                                          onChange={this.onChange('instagram')}
                                                                          value={instagram} label={'Instagram'}/>
                            }
                            {
                                this.props.signupTwitter && <InstaOrTwitter required={this.props.signupTwitterRequired}
                                                                            onChange={this.onChange('twitter')}
                                                                            value={twitter} label={'Twitter'}/>
                            }
                            {
                                this.props.signupFacebook &&
                                <PrependedInput required={this.props.signupFacebookRequired}
                                                onChange={this.onChange('facebook')} label={'Facebook'} value={facebook}
                                                prepend={'facebook.com/'}/>
                            }
                            {
                                this.props.signupYT && <PrependedInput required={this.props.signupYTRequired}
                                                                       onChange={this.onChange('youtube')}
                                                                       label={'Youtube'} value={youtube}
                                                                       prepend={'youtube.com/channel/'}/>
                            }
                            {
                                this.props.signupOtherNetwork &&
                                <PrependedInput required={this.props.signupOtherNetworkRequired}
                                                onChange={this.onChange('other_social_network')}
                                                label={'Other Social Network'} value={other_social_network}
                                                prepend={'https://'}/>
                            }
                            {
                                this.props.signupWeb && <PrependedInput required={this.props.signupWebRequired}
                                                                        onChange={this.onChange('website')}
                                                                        label={'Website/Blog'} value={website}
                                                                        prepend={'https://'}/>
                            }
                            {
                                this.props.signupAddress &&
                                <FormInput id={'Address'} required={this.props.signupAddressRequired}>
									<textarea autoComplete={'street-address'} value={address}
                                              name={'address'} onInput={this.onChange('address')}
                                              className={'form-control'}
                                    />
                                </FormInput>
                            }
                            {
                                this.props.signupCountry &&
                                <FormInput id={'Country'} required={this.props.signupCountryRequired}>
                                    <CountrySelector value={country} onChange={this.onChange('country')}/>
                                </FormInput>
                            }

                            <FormInput id={'emailAddress'} required>
                                <input type={'email'} autoComplete={'email'} value={email} name={'email'}
                                       onInput={this.onChange('email')} className={'form-control'}/>
                            </FormInput>
                            <FormInput id={'Password'} required>
                                <input type={'password'} autoComplete={'new-password'} value={password}
                                       name={'password'} onInput={this.onChange('password')}
                                       className={'form-control'}/>
                            </FormInput>
                            {
                                this.props.signupComment &&
                                <FormInput id={'Comment'} required={this.props.signupCommentRequired}>
									<textarea value={comments}
                                              name={'comments'} onInput={this.onChange('comments')}
                                              className={'form-control'}
                                    />
                                </FormInput>
                            }
                            <div className="d-flex justify-content-between align-items-center">

                                    <div className={'d-flex align-items-center'}>
                                            <StyledButton className={'btn btn-primary'} disabled={!this.shouldEnable()}
                                                          onClick={this.handleFormSubmit}
                                                          loading={this.state.loading}
                                            >
                                                <FormattedMessage id={'createAccount'}/>
                                            </StyledButton>
                                            <SponsorName/>
                                        </div>
                            <small className={'text-danger'}>* - <FormattedMessage id={'required'}/></small>
                            </div>

                        </form>
                        <OAuthSignIn/>
                    </div>
                </div>
                <small className={'d-block text-muted px-4 text-center'}>
                    <FormattedMessage id={'tosAgree'}/>
                </small>
                <div className={'mt-4 text-center'}>
                    <FormattedMessage id={'alreadyHaveAccount'}/>
                    <Link to={'/login'} className={'ml-1'}><FormattedMessage id={'Login'}/></Link>
                </div>
                <CreateAcctFooter isEmbedded={false}/>

            </AuthContainer>
        );
    }
}

function CreateAcctFooter({isEmbedded}) {

    return (<div>
        {
            !isEmbedded && <hr/>
        }
        {
            !isEmbedded &&
            <div className={'mt-4 d-flex justify-content-between'}>
                <RenderFooterUrl type={'terms_url'}/>
                <RenderFooterUrl type={'privacy_url'}/>
            </div>
        }
    </div>);
}

function PrependedInput({prepend, label, value, onChange, required}) {
    return (<div className={'form-group'}>
        <Label required={required}>{label}</Label>
        <div className="input-group">
            <div className="input-group-prepend">
                <span className="input-group-text">{prepend}</span>
            </div>
            <input type={'text'} required={required}
                   value={value} onInput={onChange}
                   className={'form-control'}
            />
        </div>
    </div>);
}

function InstaOrTwitter({required, label, value, onChange}) {
    return (<div className={'form-group'}>
        <Label required={required}>{label}</Label>
        <div className="input-group">
            <div className="input-group-prepend">
                <span className="input-group-text">@</span>
            </div>
            <input type={'text'} required={required} value={value} onInput={onChange} className={'form-control'}/>
        </div>
    </div>);
}

function RenderFooterUrl({type}) {
    return (<small><RenderLegalDocLink type={type}/></small>);
}


const fields = [
    'Name', 'Insta', 'Web', 'Twitter', 'Facebook', 'YT', 'Phone', 'Address', 'Country', 'Comment', 'OtherNetwork'
];
const dbKeys = [
    'name', 'instagram', 'website', 'twitter', 'facebook', 'youtube', 'phone', 'address', 'country', 'comments', 'other_social_network'
];

function mapStateToProps(state) {

    const map = {};
    fields.forEach((item) => {
        map['signup' + item] = state.settings['signup' + item];
        map['signup' + item + 'Required'] = state.settings['signup' + item + 'Required'];
    });

    const {isEmbedded} = state.settings;
    return {
        ...map,
        isEmbedded,
        allow_partner_registrations: state.settings.allow_partner_registrations !== undefined ? state.settings.allow_partner_registrations : true
    };
}

export default connect(mapStateToProps)(CreateAccount);
